// patchDomForTranslate.js
//
// Workaround for: "NotFoundError: Failed to execute 'removeChild' on 'Node'"
// Causa: extensiones/funciones del navegador (Google Translate, algunos
// gestores de contraseñas, ciertas extensiones de accesibilidad) mutan el DOM
// directamente envolviendo nodos de texto en <font>/<span>. Cuando React
// luego intenta reconciliar y hacer removeChild/insertBefore sobre un nodo
// que ya no está donde React cree, el navegador lanza NotFoundError y React
// desmonta el árbol (o el Error Boundary lo atrapa).
//
// Este patch NO arregla la causa raíz (para eso usa <html translate="no">),
// pero evita que la app truene si por alguna razón necesitas seguir
// soportando el traductor del navegador dentro de tu SPA.
//
// Importa este archivo UNA sola vez, lo antes posible, antes de montar React
// (por ejemplo al inicio de src/main.jsx o src/index.jsx, antes del
// ReactDOM.createRoot(...).render(...)).

if (typeof window !== "undefined" && typeof Node === "function") {
    const originalRemoveChild = Node.prototype.removeChild;
    const originalInsertBefore = Node.prototype.insertBefore;

    Node.prototype.removeChild = function removeChild(child) {
        if (child.parentNode !== this) {
            // El nodo ya no es hijo directo de este padre (el traductor lo movió
            // o lo envolvió). No hay nada válido que quitar aquí; evitamos el
            // NotFoundError y dejamos que React continúe.
            if (process.env.NODE_ENV !== "production") {
                // eslint-disable-next-line no-console
                console.warn("[patchDomForTranslate] removeChild interceptado: el nodo ya no era hijo directo.", child);
            }
            return child;
        }
        return originalRemoveChild.apply(this, arguments);
    };

    Node.prototype.insertBefore = function insertBefore(newNode, referenceNode) {
        if (referenceNode && referenceNode.parentNode !== this) {
            // El nodo de referencia ya no está en este padre; insertamos al final
            // en vez de tronar.
            if (process.env.NODE_ENV !== "production") {
                // eslint-disable-next-line no-console
                console.warn(
                    "[patchDomForTranslate] insertBefore interceptado: referenceNode ya no era hijo directo.",
                    referenceNode,
                );
            }
            return originalInsertBefore.call(this, newNode, null);
        }
        return originalInsertBefore.apply(this, arguments);
    };
}

export {};
